import React, { useState, useRef, useEffect } from 'react';
import { useRouter } from "next/router";
import Link from 'next/link';
import dynamic from 'next/dynamic';
import IMAGES from '@/public/assets/img';
import Image from 'next/image';
import AccordionBackLink from '@/component/shared/accordionBackLink';
import ContactFormStep1 from '@/component/shared/contactForm/contactFormStep1';
import ContactFormStep2 from '@/component/shared/contactForm/contactFormStep2';
import { FormProvider } from '@/component/shared/contactForm/formContext';
import MexicoForm from '@/component/shared/mexicoForm/mexicoForm';
const LedgenExitPopup = dynamic(() => import('@/component/shared/ledgenFormPopup/ledgenExitPopup'), { ssr: false });
const LedgenPopupMobileview = dynamic(() => import('@/component/shared/ledgenFormPopup/ledgenPopupMobileview'), { ssr: false });
import enIN from '@/locales/common/enIN';
import enUS from '@/locales/common/enUS';
import esMX from '@/locales/common/esMX';
import { pushCleverTapEvent } from '@/component/shared/pushCleverTapEvent';
import USForm from '@/component/shared/USForm/USForm';
import useIsMobile from '@/shared/useIsMobile';
import { ENDPOINTS } from '@/config/endpoints';

const Footer = () => {
  const router = useRouter();
  const { locale } = router;
  const t = (locale === 'es-mx' && esMX) || (locale === 'en-us' && enUS) || (locale === 'en-in' && enIN);
  const currentYear = new Date().getFullYear();
  const [showNextStep, setShowNextStep] = useState(false)
  const sectionRef = useRef(null);
  const sectionRefMobile = useRef(null);
  const [mWidth, setMWidth] = useState(0);
  const isMobile = useIsMobile();
  const [open, setOpen] = useState(false);

  const scrollToSection = () => {
    if (sectionRef.current) {
      const headerOffset = 85;
      const elementPosition = sectionRef.current.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    }
    // if(locale =='es'){
    window.gtag('event', 'getfinanceclick', {
      'event_category': 'getfinanceclick',
      'event_label': 'getfinanceclick'
    });
    if (locale === 'en-in') {
      pushCleverTapEvent("Get_Financed", { "PageName": 'HomePage', 'userProperties': 'user_lifecycle_stage', 'financing_intent_status': 'financing_intent_status', 'lead_score': 'lead_score' });
    }
    // }

  };
  const scrollToSectionMobile = () => {
    if (sectionRefMobile.current) {
      const headerOffset = 100;
      const elementPosition = sectionRef.current.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    }
    // if(locale =='es'){
    window.gtag('event', 'getfinanceclick', {
      'event_category': 'getfinanceclick',
      'event_label': 'getfinanceclick'
    });
    if (locale === 'en-in') {
      pushCleverTapEvent("Get_Financed", { "PageName": 'HomePage', 'userProperties': 'user_lifecycle_stage', 'financing_intent_status': 'financing_intent_status', 'lead_score': 'lead_score' });
    }
  };
  const toggle = () => {
    setOpen(!open);
  };
  const showSteps = () => {
    setShowNextStep(true)
  }
  const showFirstStep = () => {
    setShowNextStep(false)
  }
  const [isMounted, setIsMounted] = useState(false);

  const handleWindowResize = () => {
    setMWidth(window.innerWidth);
  }
  useEffect(() => {
    setIsMounted(true);
    handleWindowResize();
    window.addEventListener('resize', handleWindowResize);
    return () => window.removeEventListener('resize', handleWindowResize);

  }, []);

  const routers = router.pathname !== "/leadgen/export-financing-solution" &&
    router.pathname !== "/leadgen/enterprise-financing-solution" &&
    router.pathname !== "/compliance" && router.pathname !== "/interest-calculator" &&
    router.pathname !== "/blogs/[blogs]" && router.pathname !== "/news/[news]" &&
    router.pathname !== "/events/[events]" && router.pathname !== "/export-factoring/buyer-credit-check" &&
    router.pathname !== "/lead-magnet" && router.pathname !== "/global-buyer" &&
    router.pathname !== "/business-loan" && router.pathname !== "/partner-program" && router.pathname !== "/india-mexico-connect"
    && router.pathname !== "/contact-us";

  const footerMobile = router.pathname !== "/interest-calculator" && router.pathname !== "/blogs/[blogs]" &&
    router.pathname !== "/news/[news]" && router.pathname !== "/events/[events]" &&
    router.pathname !== "/lead-magnet" && router.pathname !== "/global-buyer" &&
    router.pathname !== "/business-loan" && router.pathname !== "/partner-program" && router.pathname !== "/india-mexico-connect"
    && router.pathname !== "/contact-us";

  const LeadGenExitRouters = router.pathname !== '/global-buyer' && router.pathname !== '/thankyou-response' && router.pathname !== '/india-mexico-supplier' && router.pathname !== '/india-mexico-buyer'
    && router.pathname !== '/partner-program' && !router.pathname.startsWith('/hsn-code') && !(locale === 'en-in' && router.pathname.includes('/blogs')) && router.pathname !== "/export-factoring" && router.pathname !== "/export-factoring-interest-subvention"
    && router.pathname !== '/import-factoring' && router.pathname !== '/lead-magnet' && router.pathname !== '/credlixremit' && router.pathname !== '/purchase-invoice-discounting' && router.pathname !== '/import-factoring-apply';

  const noFooterForm = router.pathname != "/export-factoring/buyer-credit-check" &&
    router.pathname != "/global-buyer" && router.pathname != "/partner-program" && router.pathname != "/interest-calculator"
    && !router.pathname.includes('blogs')

  const doMoreCardsRemove = router.pathname !== "/export-factoring/buyer-credit-check";

  return (
    <footer className={`overflow-hidden ${(locale == 'en-in') && (routers ? 'sm:min-h-[2000px]' : 'sm:min-h-[2000px]')}} relative`} id='contact-us'>
      <div className={`${!doMoreCardsRemove ? '' : 'bg-brand py-20 sm:pb-12'}`} ref={sectionRef}>
        {(routers) ? (
          <div className='sm:container md:container lg:container xl:container xm:px-2 lg:px-3 md:px-3 sm:px-3 '>
            <div className="flex flex-wrap -mx-2 flex-row-reverse justify-between">
              <div id="footersec_mobile" ref={sectionRefMobile} className='px-3 sm:w-full w-[43%] sm:mb-10'>
                {t.FooterIndiaForm &&
                  footerMobile &&
                  <FormProvider>
                    {!showNextStep ?
                      <ContactFormStep1 showStep1={showSteps} /> :
                      <ContactFormStep2 showPrevStep={showFirstStep} formType="GetInTouchNew" />
                    }
                  </FormProvider>
                }
                {t.FooterMexicoForm &&
                  <MexicoForm />
                }
                {t.FooterUSForm &&
                  <USForm />
                }
              </div>
              <div className="w-[54%] sm:w-full sm:mb-5 p-2 px-3">
                <div className="w-full">
                  <div className='mb-[30px]'>
                    <Image className='w-[190px] h-auto' width={190} height={50} src={IMAGES.footer.logo_new_credlix} alt="footer-logo" />
                  </div>
                  {t.FooterLeftText.heading &&
                    <h3 className='text-white text-xxxl sm:text-xxl leading-[40px] mb-3'>
                      {t.FooterLeftText.heading}
                    </h3>
                  }
                  {t.FooterLeftText.para &&
                    <p className='text-white text-base mb-6 xm:max-w-[80%] lg:max-w-[80%]'>{t.FooterLeftText.para}</p>
                  }


                  <div>
                    <ul className='ml-0 list-none'>
                      {t.FooterLeftText.list.map((item, i) => (
                        <li key={i} className='flex items-center mb-2'>
                          <span className='mr-1'><svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z" /><path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-.997-6l7.07-7.071-1.414-1.414-5.656 5.657-2.829-2.829-1.414 1.414L11.003 16z" fill="rgba(91,161,40,1)" /></svg></span>
                          <span className='text-white flex items-center text-base2'>{item}
                            {i === t.FooterLeftText.list.length - 1 &&
                              <Image className='w-[80px] ml-1 sm:ml-0' src={IMAGES.footer.logo_new_fci} alt="footer-FCI-logo" />
                            }
                          </span>
                        </li>
                      ))}




                    </ul>
                  </div>
                  {t.Scanner && <>
                    <div className='flex gap-5 sm:gap-2 sm:mb-[-30px] mt-14 sm:mt-4 items-start w-5/6 sm:flex-col-reverse sm:w-full sm:hidden'>
                      <div className='w-full'>
                        <Image src={IMAGES.footer.whatsappScanner} alt='whatsapp scanner' className='w-[145px] h-auto mt-xsp' width={197} height={198} />
                        <p className='text-center text-white text-sm mt-1 font-medium'>{t.ScannerText.textScan}</p></div>
                      <div className='sm:mb-3'>
                        <h3 className='text-white text-2xl font-bold mb-xsp sm:mb-3'>
                          {t.ScannerText.text1}
                        </h3>
                        <p className='text-white text-lg'> {t.ScannerText.text2}</p>
                      </div>
                    </div>
                    <div className='sm:block hidden mt-6'>
                      <Link target='_blank' rel="noopener noreferrer" href={ENDPOINTS.WHATSAPP_API}>
                        <div className='sm:mb-3 bg-white p-1 rounded-xl flex gap-1 items-center w-full'>
                          <div className='min-w-[20%]'>
                            <Image src={IMAGES.footer.whatsAppIcon} alt='whatsapp scanner' className='w-[60px] h-auto' width={60} height={60} />
                            <span className='text-[#086AC9] text-xs font-medium'>{t.ScannerText.textTapMobile}</span>
                          </div>
                          <h3 className='text-[#072F5F] text-lg font-bold w-[78%]'>
                            {t.ScannerText.text1Mobile}
                          </h3>
                        </div>
                      </Link>
                      <p className='text-white text-base2 mt-5'> {t.ScannerText.text2}</p>
                    </div>
                  </>
                  }
                </div>
              </div>
            </div>
          </div>
        ) : (doMoreCardsRemove) ? (<div className='container xm:px-2 px-3'>

          <div className="w-full">
            <div className="sm:w-full w-full p-2 sm:p-0 md:p-0">
              <div className="w-full">
                <h3 className='text-white flex flex-wrap justify-center items-center text-heading2 sm:text-lg mb-10 text-center'>
                  {t.BlueBgHeading} {t.CredlixLogoFooter ? <Image className='ml-1 sm:mt-2' src={IMAGES.SHARED.newCredlixLogoIcon} width={97} height={29} alt='Credlix Logo Icon' /> : ''}
                </h3>
                <div>
                  <ul className=' list-none flex flex-wrap justify-between max-w-[1100px] w-full mx-auto items-start'>
                    {t.SuppList.map((item, i) => (
                      <li key={i} className='flex items-center mb-4 w-[25%] sm:w-[48%] md:px-0 md:w-[48%] px-1 sm:px-0'>
                        <div className={`bg-white w-full rounded-[8px] sm:px-[10px] px-[20px] py-[20px] ${router.pathname === '/business-loan' ? 'text-center' : 'text-left min-h-[160px]'}`}  >
                          <Image src={item.image} width={68} height={66} alt={`${item.boldText}${item.text}`} className={`${router.pathname === '/business-loan' ? 'mx-auto' : ''} sm:max-w-[55px]`} />
                          <p className='text-base2 sm:text-base mt-3 min-h-[80px]'>
                            <span className='font-bold block'>{item.boldText}</span>{item.text}</p>
                        </div>
                      </li>
                    ))}

                  </ul>
                </div>


              </div>
            </div>
          </div>
        </div>) : null}

      </div>
      {/* footer bottom */}
      <div className='bg-[#EFEFF4] py-10'>

        <div className='sm:container md:container max-w-[1366px] mx-auto xm:px-2 lg:px-3 md:px-3 sm:px-3'>
          {t.Address &&

            <div className='flex flex-wrap items-center'>
              <div className='w-[70%] sm:w-full'>
                <h3 className='text-base2 text-secondary font-[500] mb-2'>{t.Address.country}</h3>
                {t.Address.addressName &&
                  <p className='text-sm text-[#5F5F60] lg:max-w-[73%] mb-1'><strong className='pr-xsp'>{t.Address.addressName.name} :</strong> <span> {t.Address.addressName.content}</span></p>
                }

                {/* <Link href={`mailto:${t.Address.emailId}`} className='text-sm text-[#5F5F60] flex flex-wrap items-center mb-1'><strong className='pr-xsp whitespace-pre'>{t.Address.email}: </strong> <span>{t.Address.emailId}</span></Link> */}
                <div className="text-sm text-[#5F5F60] mb-1"><strong className="whitespace-pre">{t.Address.email}: </strong>
                  {t.Address.emailId.split(",").map((email, index, arr) => (
                    <span key={index}>
                      <Link
                        href={`mailto:${email.trim()}`}
                        className="ml-xsp">
                        {email.trim()}
                      </Link>
                      {index < arr.length - 1 && <span>, </span>}</span>
                  ))}</div>
                <p className='text-sm text-[#5F5F60] flex sm:items-start'>
                  <strong className='pr-xsp'>{t.Address.contact}: </strong>
                  {t.Address.phone.split(',').map((phone, index, arr) => {
                    const cleanPhone = phone.replace(/[^+\d]/g, '').trim();
                    return (
                      <span key={index}>
                        <Link href={`tel:${cleanPhone}`} className='text-[#5F5F60] ml-xsp'>
                          {phone.trim()}
                        </Link>
                        {index < arr.length - 1 && <span>, </span>}
                      </span>
                    );
                  })}
                </p>

              </div>
              <div className='w-[30%] sm:w-full mt-5'>
                <div className='flex justify-end sm:justify-center md:mb-2 sm:mb-2'>
                  <Link href='https://www.linkedin.com/company/credlix/' className='mx-1' target="_blank" rel="noopener noreferrer">
                    <Image className='w-[30px] h-[30px]' src={IMAGES.FOOTER.linkedIn} alt='linkedin' />
                  </Link>
                  <Link href='https://www.facebook.com/credlix/' className='mx-1' target="_blank" rel="noopener noreferrer">
                    <Image className='w-[30px] h-[30px]' src={IMAGES.FOOTER.fb} alt='facebook' />
                  </Link>
                  <Link href='https://twitter.com/_credlix' className='ml-1' target="_blank" rel="noopener noreferrer">
                    <Image className='w-[30px] h-[30px]' src={IMAGES.FOOTER.xLogo} alt='twitter' />
                  </Link>

                </div>
                <p className='text-right sm:text-center text-sm mt-3'>{t.copyright}{currentYear}</p>
              </div>

            </div>
          }
          {t.AddressIndia &&
            <>
              <div className='flex flex-wrap items-start mb-14'>
                <div className="w-1/4 xm:w-1/2 sm:w-1/2 sm:mb-5">
                  <ul role="list" className="space-y-3">
                    {t.AddressIndia.exporters.map((item, i) => (
                      <li key={i} className='first:font-semibold'>
                        <Link href={item.href} target={item.target} onClick={item.onClick} rel="noopener noreferrer" className="text-sm hover:underline leading-6 text-secondary">
                          {item.name}
                        </Link>
                      </li>
                    ))}</ul>
                </div>
                <div className="w-1/4 xm:w-1/2 sm:w-1/2 sm:mb-5">
                  <ul role="list" className="space-y-3">
                    {t.AddressIndia.enterprises.map((item, i) => (
                      <li key={i} className='first:font-semibold'>
                        <Link href={item.href} target={item.target} onClick={item.onClick} rel="noopener noreferrer" className="text-sm hover:underline leading-6 text-secondary">
                          {item.name}
                        </Link>
                      </li>
                    ))}</ul>
                </div>
                <div className="w-1/4 xm:w-1/2 sm:w-1/2 sm:mb-5">
                  <ul role="list" className="space-y-3">
                    {t.AddressIndia.domestic.map((item, i) => (
                      <li key={i} className='first:font-semibold'>
                        <Link href={item.href} target={item.target} onClick={item.onClick} rel="noopener noreferrer" className="text-sm hover:underline leading-6 text-secondary">
                          {item.name}
                        </Link>
                      </li>
                    ))}</ul>
                </div>
                <div className="w-1/4 xm:w-1/2 sm:w-1/2 sm:mb-5">
                  <ul role="list" className="space-y-3">
                    {t.AddressIndia.company.map((item, i) => (
                      <li key={i} className='first:font-semibold'>
                        <Link href={item.href} target={item.target} onClick={item.onClick} rel="noopener noreferrer" className="text-sm hover:underline leading-6 text-secondary">
                          {item.name}
                        </Link>
                      </li>
                    ))}</ul>
                </div>
              </div>
              {/* Address section India starts */}
              <div className='flex flex-wrap items-start  mb-14'>
                <div className='w-1/4 sm:w-full sm:mb-5'>
                  <h3 className='text-base text-secondary font-semibold mb-4'>GIFT, India</h3>
                  <p className='text-sm text-secondary max-w-[90%] sm:max-w-[100%] '> </p>
                  <Link href="mailto:Pramit.joshi@moglix.com" className='text-sm text-secondary flex items-center mb-1'>
                      <svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#022B5C" width={16} height={16}>
                        <path fill="none" d="M0 0h24v24H0z"></path><path d="M2.24283 6.85435L11.4895 1.3086C11.8062 1.11865 12.2019 1.11872 12.5185 1.30878L21.7573 6.85433C21.9079 6.9447 22 7.10743 22 7.28303V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V7.28315C2 7.10748 2.09218 6.94471 2.24283 6.85435ZM18.3456 8.24383L12.0606 13.6829L5.64722 8.23769L4.35278 9.7623L12.0731 16.3171L19.6544 9.75615L18.3456 8.24383Z"></path></svg>
                      <span className='ml-1'>Pramit.joshi@moglix.com</span></Link>
                    <Link href="tel:+919820984463" className='text-sm text-secondary flex items-center mb-1'>
                      <svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#022B5C" width={16} height={16}>
                        <path fill="none" d="M0 0h24v24H0z"></path>
                        <path d="M21 16.42V19.9561C21 20.4811 20.5941 20.9167 20.0705 20.9537C19.6331 20.9846 19.2763 21 19 21C10.1634 21 3 13.8366 3 5C3 4.72371 3.01545 4.36687 3.04635 3.9295C3.08337 3.40588 3.51894 3 4.04386 3H7.5801C7.83678 3 8.05176 3.19442 8.07753 3.4498C8.10067 3.67907 8.12218 3.86314 8.14207 4.00202C8.34435 5.41472 8.75753 6.75936 9.3487 8.00303C9.44359 8.20265 9.38171 8.44159 9.20185 8.57006L7.04355 10.1118C8.35752 13.1811 10.8189 15.6425 13.8882 16.9565L15.4271 14.8019C15.5572 14.6199 15.799 14.5573 16.001 14.6532C17.2446 15.2439 18.5891 15.6566 20.0016 15.8584C20.1396 15.8782 20.3225 15.8995 20.5502 15.9225C20.8056 15.9483 21 16.1633 21 16.42Z"></path>
                      </svg>
                      <span className='ml-1'>+ 91 - 9820984463</span>
                    </Link>
                    <Link href="mailto:Aakash.mulchandani@credlix.com" className='text-sm text-secondary flex items-center mb-1'>
                      <svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#022B5C" width={16} height={16}>
                        <path fill="none" d="M0 0h24v24H0z"></path><path d="M2.24283 6.85435L11.4895 1.3086C11.8062 1.11865 12.2019 1.11872 12.5185 1.30878L21.7573 6.85433C21.9079 6.9447 22 7.10743 22 7.28303V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V7.28315C2 7.10748 2.09218 6.94471 2.24283 6.85435ZM18.3456 8.24383L12.0606 13.6829L5.64722 8.23769L4.35278 9.7623L12.0731 16.3171L19.6544 9.75615L18.3456 8.24383Z"></path></svg>
                      <span className='ml-1'>Aakash.mulchandani@credlix.com</span></Link>
                    <Link href="tel:+917678614851" className='text-sm text-secondary flex items-center'>
                      <svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#022B5C" width={16} height={16}>
                        <path fill="none" d="M0 0h24v24H0z"></path>
                        <path d="M21 16.42V19.9561C21 20.4811 20.5941 20.9167 20.0705 20.9537C19.6331 20.9846 19.2763 21 19 21C10.1634 21 3 13.8366 3 5C3 4.72371 3.01545 4.36687 3.04635 3.9295C3.08337 3.40588 3.51894 3 4.04386 3H7.5801C7.83678 3 8.05176 3.19442 8.07753 3.4498C8.10067 3.67907 8.12218 3.86314 8.14207 4.00202C8.34435 5.41472 8.75753 6.75936 9.3487 8.00303C9.44359 8.20265 9.38171 8.44159 9.20185 8.57006L7.04355 10.1118C8.35752 13.1811 10.8189 15.6425 13.8882 16.9565L15.4271 14.8019C15.5572 14.6199 15.799 14.5573 16.001 14.6532C17.2446 15.2439 18.5891 15.6566 20.0016 15.8584C20.1396 15.8782 20.3225 15.8995 20.5502 15.9225C20.8056 15.9483 21 16.1633 21 16.42Z"></path>
                      </svg>
                      <span className='ml-1'>+ 91 - 7678614851</span>
                    </Link>
                </div>

                <div className='w-3/4 sm:w-full flex-wrap flex items-center'>
                  <div className='w-1/3 sm:w-full sm:mb-5'>
                    <h3 className='text-base text-secondary font-semibold mb-4'>India</h3>
                    <Link href="mailto:enquiry@credlix.com" className='text-sm text-secondary flex items-center mb-1'>
                      <svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#022B5C" width={16} height={16}>
                        <path fill="none" d="M0 0h24v24H0z"></path><path d="M2.24283 6.85435L11.4895 1.3086C11.8062 1.11865 12.2019 1.11872 12.5185 1.30878L21.7573 6.85433C21.9079 6.9447 22 7.10743 22 7.28303V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V7.28315C2 7.10748 2.09218 6.94471 2.24283 6.85435ZM18.3456 8.24383L12.0606 13.6829L5.64722 8.23769L4.35278 9.7623L12.0731 16.3171L19.6544 9.75615L18.3456 8.24383Z"></path></svg>
                      <span className='ml-1'>enquiry@credlix.com</span></Link>
                    <Link href="tel:+917899343275" className='text-sm text-secondary flex items-center'>
                      <svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#022B5C" width={16} height={16}>
                        <path fill="none" d="M0 0h24v24H0z"></path>
                        <path d="M21 16.42V19.9561C21 20.4811 20.5941 20.9167 20.0705 20.9537C19.6331 20.9846 19.2763 21 19 21C10.1634 21 3 13.8366 3 5C3 4.72371 3.01545 4.36687 3.04635 3.9295C3.08337 3.40588 3.51894 3 4.04386 3H7.5801C7.83678 3 8.05176 3.19442 8.07753 3.4498C8.10067 3.67907 8.12218 3.86314 8.14207 4.00202C8.34435 5.41472 8.75753 6.75936 9.3487 8.00303C9.44359 8.20265 9.38171 8.44159 9.20185 8.57006L7.04355 10.1118C8.35752 13.1811 10.8189 15.6425 13.8882 16.9565L15.4271 14.8019C15.5572 14.6199 15.799 14.5573 16.001 14.6532C17.2446 15.2439 18.5891 15.6566 20.0016 15.8584C20.1396 15.8782 20.3225 15.8995 20.5502 15.9225C20.8056 15.9483 21 16.1633 21 16.42Z"></path>
                      </svg>
                      <span className='ml-1'>+91-7899343275</span>
                    </Link>
                  </div>

                  <div className='w-1/3 sm:w-full sm:mb-5'>
                    <h3 className='text-base text-secondary font-semibold mb-4'>Mexico</h3>
                    <Link href="mailto:genette.herrera@moglix.com" className='text-sm text-secondary flex items-center mb-1'>
                      <svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#022B5C" width={16} height={16}>
                        <path fill="none" d="M0 0h24v24H0z"></path><path d="M2.24283 6.85435L11.4895 1.3086C11.8062 1.11865 12.2019 1.11872 12.5185 1.30878L21.7573 6.85433C21.9079 6.9447 22 7.10743 22 7.28303V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V7.28315C2 7.10748 2.09218 6.94471 2.24283 6.85435ZM18.3456 8.24383L12.0606 13.6829L5.64722 8.23769L4.35278 9.7623L12.0731 16.3171L19.6544 9.75615L18.3456 8.24383Z"></path></svg>
                      <span className='ml-1'>genette.herrera@moglix.com</span></Link>
                    <Link href="tel:+525545449526" className='text-sm text-secondary flex items-center'>
                      <svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#022B5C" width={16} height={16}>
                        <path fill="none" d="M0 0h24v24H0z"></path>
                        <path d="M21 16.42V19.9561C21 20.4811 20.5941 20.9167 20.0705 20.9537C19.6331 20.9846 19.2763 21 19 21C10.1634 21 3 13.8366 3 5C3 4.72371 3.01545 4.36687 3.04635 3.9295C3.08337 3.40588 3.51894 3 4.04386 3H7.5801C7.83678 3 8.05176 3.19442 8.07753 3.4498C8.10067 3.67907 8.12218 3.86314 8.14207 4.00202C8.34435 5.41472 8.75753 6.75936 9.3487 8.00303C9.44359 8.20265 9.38171 8.44159 9.20185 8.57006L7.04355 10.1118C8.35752 13.1811 10.8189 15.6425 13.8882 16.9565L15.4271 14.8019C15.5572 14.6199 15.799 14.5573 16.001 14.6532C17.2446 15.2439 18.5891 15.6566 20.0016 15.8584C20.1396 15.8782 20.3225 15.8995 20.5502 15.9225C20.8056 15.9483 21 16.1633 21 16.42Z"></path>
                      </svg>
                      <span className='ml-1'>+52 55 4544 9526</span>
                    </Link>
                  </div>

                  <div className='w-1/3 sm:w-full'>
                    <h3 className='text-base text-secondary font-semibold mb-4'>United States</h3>
                    <Link href="mailto:subhrajyoti.duarah@credlix.com" className='text-sm text-secondary flex items-center mb-1'>
                      <svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#022B5C" width={16} height={16}>
                        <path fill="none" d="M0 0h24v24H0z"></path><path d="M2.24283 6.85435L11.4895 1.3086C11.8062 1.11865 12.2019 1.11872 12.5185 1.30878L21.7573 6.85433C21.9079 6.9447 22 7.10743 22 7.28303V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V7.28315C2 7.10748 2.09218 6.94471 2.24283 6.85435ZM18.3456 8.24383L12.0606 13.6829L5.64722 8.23769L4.35278 9.7623L12.0731 16.3171L19.6544 9.75615L18.3456 8.24383Z"></path></svg>
                      <span className='ml-1'> subhrajyoti.duarah@credlix.com </span></Link>
                    <Link href="tel:+528130782189" className='text-sm text-secondary flex items-center'>
                      <svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#022B5C" width={16} height={16}>
                        <path fill="none" d="M0 0h24v24H0z"></path>
                        <path d="M21 16.42V19.9561C21 20.4811 20.5941 20.9167 20.0705 20.9537C19.6331 20.9846 19.2763 21 19 21C10.1634 21 3 13.8366 3 5C3 4.72371 3.01545 4.36687 3.04635 3.9295C3.08337 3.40588 3.51894 3 4.04386 3H7.5801C7.83678 3 8.05176 3.19442 8.07753 3.4498C8.10067 3.67907 8.12218 3.86314 8.14207 4.00202C8.34435 5.41472 8.75753 6.75936 9.3487 8.00303C9.44359 8.20265 9.38171 8.44159 9.20185 8.57006L7.04355 10.1118C8.35752 13.1811 10.8189 15.6425 13.8882 16.9565L15.4271 14.8019C15.5572 14.6199 15.799 14.5573 16.001 14.6532C17.2446 15.2439 18.5891 15.6566 20.0016 15.8584C20.1396 15.8782 20.3225 15.8995 20.5502 15.9225C20.8056 15.9483 21 16.1633 21 16.42Z"></path>
                      </svg>
                      <span className='ml-1'>+52 8130782189</span>
                    </Link>
                  </div>

                </div>

              </div>
              {/* Address section India ends */}
              <div className="flex flex-wrap justify-between lg:text-center">
                {t.AddressIndia.otherWebsites &&
                  t.AddressIndia.otherWebsites.map((item, i) => (
                    <Link key={i} target="_blank" rel="noopener noreferrer" className="text-sm sm:mb-1 sm:w-[48%]" href={item.href}>{item.name}</Link>
                  ))}
              </div>
            </>
          }
          {t.BackLinks &&
            <AccordionBackLink backLinks={t.BackLinks} open={open} toggle={toggle} />
          }
          {t.CopyrightIndia &&
            <div className="flex pt-10 w-full sm:flex-col items-center">
              <div className="w-full sm:w-full flex  sm:flex-col">
                <div className='w-2/3 sm:w-full'>
                  <div className="text-base text-secondary font-medium">
                    Download Our App and Simplify Your Funding Process
                  </div>
                  <div className="text-sm text-secondary mt-1">
                    Streamline your business fund requirement with our user-friendly
                    app Download now and save time.
                  </div>
                </div>
                <div className="w-1/3 sm:w-full sm:mt-4 flex justify-end sm:justify-start">
                  <Link
                    href="https://play.google.com/store/apps/details?id=com.moglix.credlix"
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => pushCleverTapEvent("Google_Play_Download", { "PageName": 'HomePage', })}
                  >
                    <Image
                      src={IMAGES.appbanner.googlePlayBtn}
                      width={140}
                      className="w-[140px] mr-2 h-auto"
                      height={40}
                      alt="Google Play Btn"
                      quality={100}
                    />
                  </Link>
                  <Link
                    href="https://apps.apple.com/in/app/credlix/id6733239250"
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => pushCleverTapEvent("IOS_Appstore_Download", { "PageName": 'HomePage', })}
                  >
                    <Image
                      src={IMAGES.appbanner.appStoreBtn}
                      width={140}
                      className="w-[140px] h-auto"
                      height={40}
                      alt="App Store Btn"
                      quality={100}
                    />
                  </Link>
                </div>
              </div>
            </div>}
          {t.CopyrightIndia &&
            <div className="flex flex-wrap items-center mt-12">
              <div className="w-2/6 xm:w-1/3 sm:w-full ">
                <p className='text-sm text-secondary font-semibold md:text-center sm:text-center sm:mb-2'>{t.copyright}{currentYear}</p>
              </div>
              <div className="w-2/6 xm:w-1/3 sm:w-full">
                <div className='flex justify-center md:mb-2 sm:mb-2'>
                  <Link href='https://www.linkedin.com/company/credlix/' target="_blank" rel="noopener noreferrer">
                    <Image className='w-[30px] h-[30px] mx-1' src={IMAGES.FOOTER.linkedIn} alt='linkedin' />
                  </Link>
                  <Link href='https://www.facebook.com/credlix/' target="_blank" rel="noopener noreferrer">
                    <Image className='w-[30px] h-[30px] mx-1' src={IMAGES.FOOTER.fb} alt='facebook' />
                  </Link>
                  <Link href='https://twitter.com/_credlix' target="_blank" rel="noopener noreferrer">
                    <Image className='w-[30px] h-[30px] mx-1' src={IMAGES.FOOTER.xLogo} alt='twitter' />
                  </Link>

                </div>
              </div>
              <div className="w-2/6 xm:w-1/3 sm:w-full">
                <div className='flex justify-end md:justify-center sm:justify-center items-center'>
                  <Link href='/privacy-policy' target="_blank" rel="noopener noreferrer" className='text-secondary text-sm font-semibold xm:pr-2 lg:pr-6 md:pr-3 hover:underline sm:mr-1'>Privacy Policy</Link>
                  <Link href='/terms-and-conditions' target="_blank" rel="noopener noreferrer" className='text-secondary text-sm font-semibold hover:underline'>Terms Of Use</Link>
                </div>

              </div>
            </div>
          }
        </div>




      </div>
      {isMounted && footerMobile && noFooterForm && router.pathname != '/india-mexico-connect' && router.pathname != '/india-mexico-supplier' && router.pathname != '/india-mexico-buyer' &&
        <>
          {mWidth > 767 ?
            <div className={`fixed ${locale == 'es-mx' ? 'right-[-80px] bg-gradient-to-r from-[#022B5C]' : 'right-[-51px] bg-[#FECC2F] text-brand border-t-2 border-r-2 border-l-2 border-white'} px-[18px] rounded-t-md z-[98] h-[37px] -rotate-90 top-0 bottom-0 m-auto  to-[#0363C4] shadow-md transition-all duration-300 ease-in-out hover:from-[#0363C4] hover:to-[#022B5C]`}>
              <button onClick={scrollToSection} className={`block w-full h-[30px] text-center leading-[30px] ${locale == 'es-mx' ? 'text-white' : 'text-brand'}`}>
                {t.fixedCTA}
              </button>
            </div> : <div className={`fixed ${locale == 'es-mx' ? 'right-[-80px] bg-gradient-to-r from-[#022B5C] px-[18px]' : 'right-[-51px] bg-[#FECC2F] border-t-2 border-r-2 border-l-2 border-white pl-[12px] pr-[17px]'} rounded-t-md z-[98] h-[30px] -rotate-90 top-0 bottom-0 m-auto to-[#0363C4] shadow-md transition-all duration-300 ease-in-out hover:from-[#0363C4] hover:to-[#022B5C]`}>
              <button onClick={scrollToSectionMobile} className={`block w-full text-center h-[30px] leading-[30px] ${locale == 'es-mx' ? 'text-white' : 'text-brand'}`}>
                {t.fixedCTA}
              </button>
            </div>
          }
        </>
      }
      {isMounted && LeadGenExitRouters && (
        isMobile ? <LedgenPopupMobileview /> : <LedgenExitPopup />
      )}
    </footer>
  )

}

export default Footer;